import api from '@/api';

import { API_BASE_URL } from '..';
import { InventoryReportResponse, InventoryRequest } from './Report.types';

const baseUrl = API_BASE_URL;

export async function generateInventoryReport(params: InventoryRequest) {
  const result = (await api.post(
    `${baseUrl}/inventory/${params.id}/items`,
    params,
  )) as unknown;

  return result as InventoryReportResponse[];
}
